<template>
  	<PinBatchList />
</template>

<script>

// @ is an alias to /src
import PinBatchList from "@/components/SubscriptionBaseSales/subscriptionBatch//SubscriptionCodeBatchList.vue";

export default {
  name: "SubscriptionCodeBatchList",
  components: {
    PinBatchList,
  },
};
</script>
